import * as React from 'react';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import useAuth from "../Hooks/useAuth";
import { useNavigate } from 'react-router-dom';
import { profilePicture } from "../Shared/helper";
import { useEffect, useState } from 'react';
import useApiCalls from "../Hooks/useApiCalls";

export default function Profile({profileImage}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [image, setImage] = useState(null);
  const authCtx = useAuth();
  const api = useApiCalls();
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    authCtx.logout();
    navigate("/", { replace: true });
  };

  const handleRedirect = () => {
    navigate("/account");
  }

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const res = await api(profilePicture, 'get', null, { responseType: 'blob' });
        if(res.data.size === 4){
          setImage(null);
        }else{
          const imageUrl = URL.createObjectURL(res.data); 
          setImage(imageUrl);
        }
      } catch (error) {
        console.error('Error fetching image:', error);
      }
    };
    fetchImage();
  }, []);

  return (
    <React.Fragment>
      <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>

        <Tooltip>
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? 'account-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            className='align-items-center'
          >
            <img 
            className='header-profile' 
            src={profileImage || (image ? image : "/assets/images/ac-user-img.jpg")} 
            alt="" 
            onError={(e) => { e.target.onerror = null; e.target.src="/assets/images/ac-user-img.jpg"; }}
          />
            <p className='mb-0 profile-name'>{authCtx.user.username.slice(0, 6)+'..'}</p> <img className='arrow-img' src="/assets/images/arrow.png" alt="" />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={handleRedirect}>
          Profile
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          Logout
        </MenuItem>
      </Menu>
    </React.Fragment>
  );
}

